import React, { createContext, useContext } from 'react';

// Split contexts: data (changes often) vs actions (stable refs via useCallback/useMemo)
// This gives fine-grained re-render control for tabs that only need handlers.
const AdminDataContext = createContext(null);
const AdminActionsContext = createContext(null);

export const AdminProvider = ({ data, actions, children }) => (
  <AdminActionsContext.Provider value={actions}>
    <AdminDataContext.Provider value={data}>
      {children}
    </AdminDataContext.Provider>
  </AdminActionsContext.Provider>
);

export const useAdminData = () => {
  const ctx = useContext(AdminDataContext);
  if (!ctx) throw new Error('useAdminData must be used within AdminProvider');
  return ctx;
};

export const useAdminActions = () => {
  const ctx = useContext(AdminActionsContext);
  if (!ctx) throw new Error('useAdminActions must be used within AdminProvider');
  return ctx;
};

/**
 * Backwards-compatible combined hook.
 * Returns merged { ...data, ...actions } for tabs that still consume via single destructure.
 * New code should prefer useAdminData() or useAdminActions() for better re-render isolation.
 */
export const useAdminContext = () => {
  const data = useAdminData();
  const actions = useAdminActions();
  return { ...data, ...actions };
};

export default AdminDataContext;
